import { FormInputField, FormTextareaField, LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UncontrolledNumberInputField } from '@mews-commander/form';
import { FIELD_NAMES } from '../formEnums';

interface Props {
    isDisabled?: boolean;
    isRateGroupKeyDisabled?: boolean;
    isRateGroupKeyRequired?: boolean;
}

export const GeneralDetailsMetaFields = ({
    isDisabled,
    isRateGroupKeyDisabled,
    isRateGroupKeyRequired = true,
}: Props) => (
    <>
        <FormInputField
            name={FIELD_NAMES.NAME}
            label={<LocalizedText textKey={TextKey.RateGroupGeneralDetailsName} />}
            required
            disabled={isDisabled}
            size="medium"
        />

        <FormInputField
            name={FIELD_NAMES.SHORT_NAME}
            label={<LocalizedText textKey={TextKey.ShortName} />}
            disabled={isDisabled}
            size="medium"
        />

        <FormTextareaField
            name={FIELD_NAMES.DESCRIPTION}
            label={<LocalizedText textKey={TextKey.Description} />}
            disabled={isDisabled}
        />

        <FormInputField
            name={FIELD_NAMES.RATE_GROUP_KEY}
            label={<LocalizedText textKey={TextKey.RateGroupKey} />}
            helper={lt('RateGroupKeyFieldHelper')}
            required={isRateGroupKeyRequired}
            disabled={isDisabled || isRateGroupKeyDisabled}
            size="medium"
        />

        <UncontrolledNumberInputField
            required
            name={FIELD_NAMES.ORDERING}
            label={<LocalizedText textKey={TextKey.Ordering} />}
            helper={lt('RateGroupOrderingFieldHelper')}
            disabled={isDisabled}
            size="medium"
            type="number"
        />
    </>
);
